var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChatUnread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "218.098 184.442 20 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 20 6.98 L 20 16 C 20 17.1 19.1 18 18 18 L 4 18 L 0 22 L 0 4 C 0 2.9 0.9 2 2 2 L 12.1 2 C 12.04 2.32 12 2.66 12 3 C 12 3.34 12.04 3.6799999999999997 12.1 4 L 2 4 L 2 16 L 18 16 L 18 7.9 C 18.74 7.75 19.42 7.42 20 6.98 Z",
    fill: "#073c7a",
    transform: "matrix(1, 0, 0, 1, 218.097809, 184.441696)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 14 3 C 14 4.66 15.34 6 17 6 C 18.66 6 20 4.66 20 3 C 20 1.3399999999999999 18.66 0 17 0 C 15.34 0 14 1.3399999999999999 14 3 Z",
    transform: "matrix(1, 0, 0, 1, 218.097809, 184.441696)",
    style: {
      fill: "rgb(255, 0, 0)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatUnread);
export default __webpack_public_path__ + "static/media/icon_chat_unread.2204dc41a98ba2127d1c8a68f9407037.svg";
export { ForwardRef as ReactComponent };